import { Component, HostBinding, Input } from '@angular/core';
import { Assortment } from '../../base/models';

@Component({
  selector: 'py-assortment-table',
  templateUrl: './assortment-table.component.html',
  styleUrls: ['./assortment-table.component.scss'],
  standalone: false,
})
export class AssortmentTableComponent {
  @Input() assortment: Assortment[];
  @Input() grammages;

  @Input()
  @HostBinding('class.show-sku-picker')
  pdpTypeSkuPicker: boolean = true;

  get tableClass() {
    return this.pdpTypeSkuPicker ? '' : 'table-grey';
  }

  constructor() {}
}
